import * as React from 'react';
import * as classnames from 'classnames/bind';
import {observer} from 'mobx-react';
import {Dialog} from '@mintdata-wsp/wsp/ui/components/forms/Dialog';
import {Column} from "@mintdata-wsp/wsp/ui/components/forms/Column";
import {Row} from "@mintdata-wsp/wsp/ui/components/forms/Row";
import {rootState} from "@mintdata-wsp/common/state/RootState";

const styles = require('./InvoiceDetailsDialog.less');
const cx = classnames.bind(styles);

@observer
export class InvoiceDetailsDialog extends React.Component<any, any>
{
    private _formatDate(date:number):string
    {
        return (new Date(date)).toString().substr(4,11);
    }

    private _renderLine(label:string, value:string, className?:string)
    {
        return (
            <Row className={cx('line', className)}>
                <span className={cx('label')}>{label}</span>
                <span className={cx('value')}>{value}</span>
            </Row>
        )
    }

    render()
    {
        const invoice = rootState.ui.invoices.invoiceDetails;

        if (!invoice) return null;

        const {rows = []} = invoice;

        const orgName  = rootState.userSession.currentOrganization.name;
        const userName = rootState.userSession.currentUser.fullName;

        const {location} = window;
        const orgUrl = `${location.protocol}//${location.hostname}`;

        let number = invoice.number;

        if (number < 100) number = ('00' + number).slice(-3);

        const periodStart = this._formatDate(invoice.periodStart);
        const periodEnd   = this._formatDate(invoice.periodEnd);

        const cloudAccessAmount = invoice.cloudAccessAmount.toFixed(2);
        const addonsAmount = invoice.addonsAmount ? invoice.addonsAmount.toFixed(2) : 0;
        const totalAmount = invoice.totalAmount.toFixed(2);

        // TODO do not calculate - take from server
        const total = rows.reduce((prev, cur) => { return prev + cur.rowAmount}, 0).toFixed(2);

        return  (
            <Dialog>

                <Column className={cx('invoiceDetailsDialog')}>

                    <Row className={cx('blocks')}>

                        <Column className={cx('block', 'org')}>
                            <span className={cx('orgName')}>{orgName}</span>
                            <span>{userName}</span>
                            <a className={cx('link')} href="#">{orgUrl}</a>
                        </Column>

                        <Column className={cx('block', 'mintdata')}>
                            <b>MintData</b>
                            <span>620 Folsom St.</span>
                            <span>San Francisco, CA 94107</span>
                            <a className={cx('link')} href="mailto:invoices@mintdata.com">invoices@mintdata.com</a>
                        </Column>

                    </Row>

                    <Row className={cx('groupHead')}>
                        Overview
                    </Row>

                    <Row className={cx('blocks')}>

                        <Column className={cx('block')}>
                            {this._renderLine('Invoice',`#${number}`, cx('number'))}
                            {this._renderLine('From', periodStart)}
                            {this._renderLine('To',   periodEnd)}
                        </Column>

                        <Column className={cx('block')}>
                            {this._renderLine('Cloud Access',
                                              `$${cloudAccessAmount}`)
                            }
                            {this._renderLine('Addons',
                                              addonsAmount ? `$${addonsAmount}` : '-')
                            }
                            {this._renderLine('Total',
                                              `$${totalAmount}`,
                                               cx('total'))
                            }
                        </Column>

                    </Row>

                    <Row className={cx('groupHead')}>
                        Details
                    </Row>

                    <Column className={cx('rows')}>
                        <Row className={cx('row', 'head')}>
                            <span className={cx('fromDate')}>From</span>
                            <span className={cx('toDate')}>To</span>
                            <span className={cx('description')}>Item</span>
                            <span className={cx('unitPrice')}>Price</span>
                            <span className={cx('unitPeriod')}>Per</span>
                            <span className={cx('quantity')}>Quantity</span>
                            <span className={cx('rowAmount')}>Amount</span>
                        </Row>
                        {rows.map((row, index) => { return (
                            <Row key={row.subscriptionId} className={cx('row')}>
                                <span className={cx('fromDate')}>{this._formatDate(row.fromDate)}</span>
                                <span className={cx('toDate')}>{this._formatDate(row.toDate)}</span>
                                <span className={cx('description')}>{row.description}</span>
                                <span className={cx('unitPrice')}>${row.unitPrice.toFixed(2)}</span>
                                <span className={cx('unitPeriod')}>{row.unitPeriod}</span>
                                <span className={cx('quantity')}>{row.quantity}</span>
                                <span className={cx('rowAmount')}>${row.rowAmount.toFixed(2)}</span>
                            </Row>
                        )})}
                        <Row className={cx('row', 'total')}>
                            <span className={cx('fromDate')}/>
                            <span className={cx('toDate')}/>
                            <span className={cx('description')}/>
                            <span className={cx('unitPrice')}/>
                            <span className={cx('unitPeriod')}>Total</span>
                            <span className={cx('quantity')}/>
                            <span className={cx('rowAmount')}>${total}</span>
                        </Row>
                    </Column>

                </Column>

            </Dialog>
        );
    }
}
